import { render, staticRenderFns } from "./CampaignBlock.vue?vue&type=template&id=fda247d6&scoped=true"
import script from "./CampaignBlock.vue?vue&type=script&lang=js"
export * from "./CampaignBlock.vue?vue&type=script&lang=js"
import style0 from "./CampaignBlock.vue?vue&type=style&index=0&id=fda247d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda247d6",
  null
  
)

export default component.exports